import MarkdownRenderer from "../../../components/MarkdownRenderer";
import { useIsMobile } from "../../../utils/useIsMobile";
import { IMessage } from "../../../@DTO/chat";
import getColorChatUser from "../../../utils/getColorChatUser";
import { useTheme } from "../../../contexts/ThemeContext";

interface UserMessageProps {
  message: IMessage;
}

const UserMessage = ({ message }: UserMessageProps) => {
  const {addTheme} = useTheme();
  const isMobile = useIsMobile();
  const textUserMobile = window.innerWidth < 400 && 245;
  const { theme, background } = getColorChatUser(addTheme);
  
  return (  
    <section
      className="d-flex align-items-start align-self-end"
      style={{
        padding: isMobile ? "16px 16px" : "16px 24px",
        borderRadius: "35px 8px 35px 35px",
        marginBottom: isMobile ? 10 : 25,
        maxWidth: "80%",
        background: background,
      }}
    >
      <div
        className="col d-flex align-items-start gap-3 w-100"
        style={{ color: theme }}
      >
        <div
          className="align-self-center w-100"
          style={{
            wordBreak: "break-word",
            overflowWrap: "break-word",
            maxWidth: textUserMobile ? 245 : "100%",
          }}
        >
          <MarkdownRenderer
            className="mb-0 markdown"
            content={message?.data?.content as string}
            data-is-request={true}
          />
        </div>
      </div>
    </section>
  );
};

export default UserMessage;
